export const MAX_INT = 0x7fffffff; // 2^32-1, the max value for signed 32-bit ints.
export const MAX_INT_DESCRIPTION = "2^31 - 1";
export const MIN_INT = -0x80000000;
export const MINT_INT_DESCRIPTION = "-2^31";
